<template>
	<div class="flex flex_wrap homeequip-wrap">
		<div
			v-for="(item, index) in dataList"
			:key="index"
			class="flex flex_ju_sb flex_a_c equip-div"
			@click="linkChange(item)"
		>
			<div>
				<div class="font_16">{{ item.name }}</div>
				<div class="bold font_30 equip-val">{{ item.value }}</div>
			</div>
			<img class="img_icon" :src="item.icon" alt="" />
		</div>
	</div>
</template>

<script>
/**
 * @description 首页的设备数据模块
 */
import { getAction } from '@/api/request'
export default {
	data() {
		return {
			// 列表数据
			dataList: [
				{
					name: '设备总数',
					type: '总数',
					value: '--',
					icon: require('@/assets/image/home/icon1.png'),
					isTap: true,
				},
				{
					name: '设备异常',
					type: '异常',
					value: '0',
					icon: require('@/assets/image/home/icon2.png'),
				},
				{
					name: '控制箱设备',
					type: '控制箱',
					value: '--',
					icon: require('@/assets/image/home/icon3.png'),
				},
				{
					name: '水肥设备',
					type: '水肥',
					value: '--',
					icon: require('@/assets/image/home/icon4.png'),
				},
				{
					name: '气象设备',
					type: '气象',
					value: '--',
					icon: require('@/assets/image/home/icon5.png'),
				},
				{
					name: '监控设备',
					type: '监控',
					value: '--',
					icon: require('@/assets/image/home/icon6.png'),
				},
				{
					name: '墒情设备',
					type: '土壤',
					value: '--',
					icon: require('@/assets/image/home/icon7.png'),
				},
				{
					name: '虫情设备',
					type: '虫情',
					value: '--',
					icon: require('@/assets/image/home/icon8.png'),
				},
			],
		}
	},
	mounted() {
		// 获取设备数据
		this.loadData()
	},
	methods: {
		// 获取数据
		loadData() {
			// TODO 该字段需要动态获取
			let params = {
				orgCode: '290-1-3',
			}
			getAction(this.$api.firstPageCount, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						if (datas && datas.length) {
							this.dataList.forEach((items, index) => {
								datas.forEach((item) => {
									if (item.name.indexOf(items.type) > -1) {
										this.dataList[index]['value'] = item.num
									}
								})
							})
						}
					} else {
						this.dataList.forEach((items, index) => {
							this.dataList[index]['value'] = '--'
						})
					}
				})
				.catch((err) => {
					this.dataList.forEach((items, index) => {
						this.dataList[index]['value'] = '--'
					})
				})
		},
		// 点击跳转
		linkChange({ isTap }) {
			if (!isTap) return
			this.$router.push('/equipList')
		},
	},
}
</script>

<style lang="scss">
.homeequip-wrap {
	height: 100%;
	.equip-div {
		// width: 3.05rem;
		width: 23.28%;
		height: 46.48%;
		background: #ffffff;
		border-radius: 0.25rem;
		margin-left: 0.94vw;
		padding: 0 1.64vw 0 1.86vw;
		color: #454545;
		&:first-child {
			cursor: pointer;
		}
		&:nth-child(4n + 1) {
			margin-left: 0;
		}
		&:nth-child(n + 5) {
			margin-top: 2.43vh;
		}
		.equip-val {
			margin-top: 0.3rem;
			text-align: left;
		}
	}
	.img_icon {
		width: 4.38vw;
		height: 4.38vw;
	}
}
</style>
